if (!customElements.get("variant-selects")) {
  customElements.define(
    "variant-selects",
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        setTimeout(() => {
        this.initAllSelectedOptions()
        });
      }

      get selectedOptionValues() {
        return Array.from(
          this.querySelectorAll(
            "select option[selected], fieldset input:checked"
          )
        ).map(({ dataset }) => dataset.optionValueId);
      }

      initAllSelectedOptions() {
        const initedOptionsIds = Array.from(this.querySelectorAll(
            "select option[selected], fieldset input:checked"
          )).map(({ dataset }) => dataset.optionValueId)
        initedOptionsIds.forEach((id) => {
          const doms = this.querySelectorAll(`input[data-option-value-id="${id}"]`)
          if (doms.length) {
            doms.forEach((dom) => {
              if (dom.checked) return
              dom.classList.add('active')
            })
          }
        })
      }

      getInputForEventTarget(target) {
        return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener("change", (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(
            FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
            {
              data: {
                event,
                target,
                selectedOptionValues: this.selectedOptionValues,
                from: "variantSelect",
              },
            }
          );
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === "SELECT" && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute("selected"))
            .removeAttribute("selected");
          target.selectedOptions[0].setAttribute("selected", "selected");

          const swatchValue =
            target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest(".product-form__input")
            .querySelector("[data-selected-value] > .swatch");
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              swatchValue
            );
            selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
          } else {
            selectedDropdownSwatchValue.style.setProperty(
              "--swatch--background",
              "unset"
            );
            selectedDropdownSwatchValue.classList.add("swatch--unavailable");
          }

          selectedDropdownSwatchValue.style.setProperty(
            "--swatch-focal-point",
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || "unset"
          );
        } else if (tagName === "INPUT" && target.type === "radio") {
          const selectedSwatchValue = target
            .closest(`.product-form__input`)
            .querySelector("[data-selected-value]");
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}


if (!customElements.get("variant-picker-tabs")) {
  customElements.define(
    "variant-picker-tabs",
    class VariantPickerTabs extends HTMLElement {
      constructor() {
        super()
        this.tabHeaderWrapperDom = this.querySelector('.product-variant-picker-tab-header-wrapper')
        this.tabHeaderContentDom = this.querySelector('.product-variant-picker-tab-header')
        this.tabLeftButtonDom = this.querySelector('.left-button')
        this.tabRightButtonDom = this.querySelector('.right-button')
        this.tabButtonsDom = this.querySelector('.switch-buttons')
        requestAnimationFrame(() => {
          this.init()
        })
      }

      init() {
        const { scrollWidth, offsetWidth } = this.tabHeaderWrapperDom
        if (scrollWidth > offsetWidth) {
          this.classList.add('scrollable')
        }
        this.tabLeftButtonDom.addEventListener('click', this.handleToLeft.bind(this)) 
        this.tabRightButtonDom.addEventListener('click', this.handleToRight.bind(this))
      }

      handleToLeft() {
        const { scrollWidth, offsetWidth, scrollLeft } = this.tabHeaderWrapperDom
        if (scrollLeft > 0) {
          const newScrollLeft = Math.max(scrollLeft - 150,0)
          this.tabHeaderWrapperDom.scrollTo({left: newScrollLeft, behavior: 'smooth' })
          if (newScrollLeft === 0) {
            this.tabLeftButtonDom.classList.add('disabled')
          }
          this.tabRightButtonDom.classList.remove('disabled')
        }
      }

      handleToRight() {
        const { scrollWidth, offsetWidth, scrollLeft } = this.tabHeaderWrapperDom
        if (scrollLeft + offsetWidth < scrollWidth) {
          const newScrollLeft = Math.min(scrollLeft + 150,scrollWidth - offsetWidth)
          this.tabHeaderWrapperDom.scrollTo({left: newScrollLeft, behavior: 'smooth' })
          if (newScrollLeft >= scrollWidth - offsetWidth) {
            this.tabRightButtonDom.classList.add('disabled')
          }
          this.tabLeftButtonDom.classList.remove('disabled')
        }
      }
    }
  )}